const filteredOptions = [
	{ value: 'Prod', label: 'Prod', color: 'colorEnvProd' },
	{ value: 'PreProd', label: 'PreProd', color: 'colorEnvPreProd' },
	{ value: 'Dev', label: 'Dev', color: 'colorEnvDev' },
];

export default filteredOptions;